<div class="no-access content">
        <h2>{{authorizedString}}</h2>
</div>